"use client"
import {Button, Link} from "@chakra-ui/react";

export function EmailLink({email, subject, text}: {email?: string; subject?: string, text?: string}) {
    const to = email ?? "info@happyhours.lv"
    return (
        <Link href={`mailto:${to}?subject=${subject ?? ""}&body=${text ?? ""}`}>
            <Button variant="link">
                {to}
            </Button>
        </Link>
    )
}